e4.favorites = {
    bindEventsDone: false,
    init: function () {
        if (jQuery('.js-e-product-favorites,.js-e-favorites-list-modal,.js-bionordika-cart-favorites,.js-bionordika-favorites-list-detail, .js-bionordika-favouritlist-form').length > 0) {
            e4.favorites.bindEvents();
        }
        if (jQuery('.js-e-nav-item-favorites').length > 0) {
            e4.favorites.product.updateQuantityInfo();
        }

        if (jQuery('.js-bionordika-cart-favorites').length > 0) {
            e4.require.js(e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates('.js-e-handlebars-tmpl-cart-favorites-lists');
                e4.handlebars.registerHelpers('multiCompare');
            });
        }
        if (jQuery('.js-bionordika-favoritlist-search').length > 0) {
            e4.favorites.search.bindEvents();
        }
    },
    bindEvents: function () {
        jQuery(document).on('show.bs.modal', '#js-e-favorites-rename-list-modal', function (event) {
            e4.favorites.setFormValues(event.target, event.relatedTarget);
        }).on('shown.bs.modal', '.js-e-favorites-list-modal', function (event) {
            e4.favorites.setFormInputFocus(event.target);
        }).on('hidden.bs.modal', '#js-e-favorites-rename-list-modal', function (event) {
            e4.favorites.clearFormValues(event.target);
        });

        // TODO: Refactor to use require namespace to fix this
        if (e4.favorites.bindEventsDone === false) {
            e4.favorites.bindEventsDone = true;

            jQuery(document)
                .on('change', '.js-e-product-favorites-list-input', function (event) {
                    e4.favorites.product.toggleList(event.target);
                })
                .on('click', '.js-e-product-favorites-create-list-submit-btn', function (event) {
                    e4.favorites.product.createList(event.target);
                })
                .on('keydown keypress', '.js-e-product-favorites-create-list-name-input', function (event) {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        e4.favorites.product.createList(event.target);
                    }
                })
                .on('click', '.js-bionordika-add-all-products-to-favoritlist-btn', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                })
                .on('click', '.js-bionordika-favoritelist-remove-item-btn', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    const jElement = jQuery(event.currentTarget);
                    e4.util.ajax({
                        url: jElement.data('urlRemove'),
                        dataType: 'html',
                    }, function (htmlDocument) {
                        var timer;
                        const html = jQuery(htmlDocument).find('.js-bionordika-favoritelist-detail-container').html();

                        jElement.closest('.js-e-productlist-item').addClass('is-removed');
                        clearTimeout(timer);
                        timer = setTimeout(
                            function () {
                                jQuery('.js-bionordika-favoritelist-detail-container').html(html);
                                e4.favorites.product.updateQuantityInfo();
                            }, 1000);


                    });
                })
                .on('show.bs.dropdown', '.js-bionordika-cart-favorites', function (event) {
                    e4.favorites.product.buildListsToCart(event);
                })
                .on('shown.bs.collapse', '.js-e-product-favorites-create-list', function (event) {
                    e4.favorites.product.setCreateListNameInputFocus(event.target);
                }).on('show.bs.dropdown', '.js-e-product-favorites', function (event) {
                    e4.favorites.product.buildLists(event.target);
                }).on('hidden.bs.dropdown', '.js-e-product-favorites', function (event) {
                    e4.favorites.product.clearLists(event.target);
                });

            jQuery('.js-bionordika-cart-favorites').on('change', '.js-bionordika-cart-favorites-list-input', function (event) {
                const jInput = jQuery(event.currentTarget);
                e4.favorites.cart.addToList(jInput);
            });

            jQuery(document).on('change', '.js-bionordika-favouritlist-form', function (event) {
                jQuery(event.currentTarget).attr('action', location.href).submit();
            });
        }
    },
    setFormInputFocus: function (domModal) {
        jQuery(domModal).find('input[type="text"]').first().trigger('focus');
    },
    setFormValues: function (domModal, domTriggerNode) {
        const jModal = jQuery(domModal),
            jTriggerNode = jQuery(domTriggerNode);
        jModal.find('.js-e-favorites-rename-list-form').attr('action', function () {
            return jTriggerNode.attr('href');
        }).find('.js-e-favorites-rename-list-form-name-input').val(jTriggerNode.data('list-name'));
    },
    clearFormValues: function (domModal) {
        jQuery(domModal).find('.js-e-favorites-rename-list-form').attr('action', '').find('.js-e-favorites-rename-list-form-name-input').val('');
    },
    search: {
        bindEvents: function () {
            jQuery('.js-bionordika-favoritlist-search').on('input', '.js-bionordika-favoritlist-search-input', e4.util.debounce(function (event) {
                e4.favorites.search.getResult(event);
            }, 1000));
        },
        getResult: function (event) {
            const formData = jQuery(event.currentTarget).closest('form').serialize();
            e4.util.ajax({
                url: e4.settings.ecom.favorites.search.url,
                data: formData,
                dataType: 'json',
                beforeSend: function () {
                    jQuery('.js-bionordika-favorites-list-container').find('.js-e-loading-overlay').addClass('is-loading');
                    jQuery('.js-bionordika-favorites-list-container').find('.js-favorites-list-item').addClass('d-none');
                }
            }, function (jsonData) {
                jQuery.each(jsonData, function (intIndex, objDataElement) {
                    jQuery('.js-bionordika-favorites-list-container').find('.js-favorites-list-item[data-favorit-list-id="' + objDataElement.ListId + '"]').removeClass('d-none');
                });
                jQuery('.js-bionordika-favorites-list-container').find('.js-e-loading-overlay').removeClass('is-loading');
            });
        }
    },
    cart: {
        toggleIcon: function (jInput) {
            if (jInput.closest('.js-e-product-favorites-lists').find('input:checked').length > 0) {
                jInput.closest('.js-eldorado-cart-favorites').find('.bionordika-productlist-addtofavorites-icon').addClass('in-favoritlist');
            }
            else {
                jInput.closest('.js-eldorado-cart-favorites').find('.bionordika-productlist-addtofavorites-icon').removeClass('in-favoritlist');
            }
        },
        addToList: function (jInput) {
            jInput.prop('disabled', true);
            e4.cc.ajax({
                url: e4.settings.ecom.favorites.url + '?action=AddCartToFavoritList&listId=' + jInput.val() + '&Redirect=false'
            }, function (data) {
                jInput.closest('.dropdown').find('.js-bionordika-add-all-products-to-favoritlist-btn').trigger('click');
                e4.favorites.cart.toggleIcon(jInput);
                e4.favorites.product.updateQuantityInfo(data.count);
            });
        },
    },
    product: {
        ajax: function (objAjaxSettings, fnCallback) {
            const jqXHR = jQuery.ajax(jQuery.extend({
                url: e4.settings.ecom.favorites.url,
                dataType: 'json',
                method: 'GET',
                cache: false
            }, objAjaxSettings));
            jqXHR.done(function (jsonData) {
                if (typeof fnCallback === 'function') {
                    fnCallback(jsonData);
                }
            });
            jqXHR.fail(function (data, textStatus, errorThrown) {
                console.error(data, textStatus, errorThrown);
            });
        },
        toggleList: function (domInput) {
            const jInput = jQuery(domInput);
            if (jInput.prop('checked') === true) {
                e4.favorites.product.addToList(jInput);
            }
            else {
                e4.favorites.product.removeFromList(jInput);
            }
        },
        addToList: function (jInput) {
            jInput.prop('disabled', true);
            e4.util.ajax({
                url: jInput.data('url-add')
            }, function (data) {
                jInput.prop('disabled', false);
                e4.favorites.product.toggleIcon(jInput, data);
            });
        },
        removeFromList: function (jInput) {
            jInput.prop('disabled', true);
            e4.util.ajax({
                url: jInput.data('url-remove')
            }, function (data) {
                jInput.prop('disabled', false);
                e4.favorites.product.toggleIcon(jInput, data);
            });
        },
        toggleIcon: function (jInput, data) {
            if (jInput.closest('.js-e-product-favorites-lists').find('input:checked').length > 0) {
                jInput.closest('.js-e-product-favorites').find('.bionordika-addtofavorites-icon').addClass('in-favoritlist');
            }
            else {
                jInput.closest('.js-e-product-favorites').find('.bionordika-addtofavorites-icon').removeClass('in-favoritlist');
            }
            e4.favorites.product.updateQuantityInfo(data.count);

        },
        updateQuantityInfo: function (intQuantity) {
            const jFavoritesQuantity = jQuery('.js-e-favorites-quantity');
            if (jFavoritesQuantity.length > 0) {
                if (jQuery.isNumeric(intQuantity) === false) {
                    e4.favorites.product.ajax({
                        method: 'GET'
                    }, function (jsonData) {
                        if (jQuery.isNumeric(jsonData.count) === true) {
                            e4.favorites.product.updateQuantityInfo(jsonData.count);
                        }
                    });
                }
                else if (intQuantity === 0) {
                    jFavoritesQuantity.empty();
                }
                else {
                    jFavoritesQuantity.html(intQuantity);
                }
            }
        },
        addToNewList: function (domNode, intLastAddedId) {
            const jNewListInput = jQuery(domNode).closest('.js-e-product-favorites').find('.js-e-product-favorites-list-input[data-list-id="' + intLastAddedId + '"]');
            jNewListInput.closest('.dropdown-item').addClass('bg-light');
            e4.favorites.product.toggleList(jNewListInput.prop('checked', true).get(0));
        },
        setCreateListNameInputFocus: function (domNode) {
            jQuery(domNode).find('.js-e-product-favorites-create-list-name-input').trigger('focus');
        },
        createList: function (domNode) {
            const jFavoritesCreateList = jQuery(domNode).closest('.js-e-product-favorites-create-list'),
                jFavorites = jFavoritesCreateList.closest('.js-e-product-favorites'),
                jNameInput = jFavoritesCreateList.find('.js-e-product-favorites-create-list-name-input');
            if (jNameInput.val() !== '') {
                e4.util.ajax({
                    url: jFavoritesCreateList.data('create-list-url'),
                    method: 'POST',
                    beforeSend: function () {
                        jFavorites.find('.js-e-loading-overlay').addClass('is-loading');
                    },
                    data: {
                        Name: jNameInput.val(),
                    }
                }, function () {
                    jFavorites.one('loaded.e4.jsonpublisher', function (event, jsonData) {
                        e4.favorites.product.addToNewList(event.target, jsonData.lastAddedListId);
                    });

                    if (jQuery(domNode).closest('.js-bionordika-cart-favorites').length > 0) {
                        e4.favorites.product.buildListsToCart(domNode);
                    } else {
                        e4.favorites.product.buildLists(domNode);
                    }

                    jNameInput.val('');
                    jFavoritesCreateList.find('.js-e-product-favorites-create-list').collapse('hide');
                });
            }
            else {
                jNameInput.trigger('focus');
            }
        },
        buildLists: function (domNode) {
            const jFavorites = jQuery(domNode).closest('.js-e-product-favorites'),
                domFavorites = jFavorites.get(0);
            jFavorites.find('.js-e-loading-overlay').addClass('is-loading');
            e4.jsonpublisher.reload(domFavorites, {
                jsonSrc: e4.settings.ecom.favorites.url
            }).done(function () {
                jFavorites.find('.js-e-loading-overlay').removeClass('is-loading');
            });
        },
        clearLists: function (domNode) {
            jQuery(domNode).find('.js-e-product-favorites-lists').html('');
        },
        buildListsToCart: function (event) {
            let objProductDataSettings, jListItems, jElement;
            const inCartContext = event.currentTarget === undefined;
            if (inCartContext) {
                jElement = jQuery(event);
                objProductDataSettings = jElement.data();
                jListItems = jElement.closest('.js-bionordika-cart-favorites').find('.js-e-product-cart-favorites-lists');
            } else {
                jElement = jQuery(event.currentTarget);
                objProductDataSettings = jElement.data();
                jListItems = jElement.find('.js-e-product-cart-favorites-lists');
            }

            e4.favorites.product.ajax({
                data: objProductDataSettings,
                beforeSend: function () {
                    jElement.find('.js-e-product-favorites-loader').addClass('is-loading');
                }
            }, function (jsonData) {
                jsonData.inCartContext = inCartContext;
                e4.favorites.product.buildList(jListItems, jsonData);
                jElement.find('.js-e-product-favorites-loader').removeClass('is-loading');
            });
        },
        buildList: function (jListItems, jsonData) {
            jListItems.html(e4.handlebars.tmpl.cartFavoritesLists(jsonData));
        }
    }
};
